import { render, staticRenderFns } from "./WaitingRoomDialogsTable.vue?vue&type=template&id=edb8ef52&"
import script from "./WaitingRoomDialogsTable.vue?vue&type=script&lang=babel&"
export * from "./WaitingRoomDialogsTable.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports